import {
  ADMIN_ROLES,
  MANAGEMENT_ROLES
} from '@space-shell/common/hooks/useUserPermissions/constants'
import type {
  CommunityMemberPermissions,
  PermissionActions
} from '@space-shell/common/services/communities'

const useUserPermissions = () => {
  const hasAdminRole = (group: CommunityMemberPermissions['group']) => {
    if (!group) {
      return false
    }

    return Object.values(ADMIN_ROLES).some((role) => group === role)
  }

  const hasCommunityManagementRole = (group: CommunityMemberPermissions['group']) => {
    if (!group) {
      return false
    }

    return Object.values(MANAGEMENT_ROLES).some((role) => group === role)
  }

  const hasPermission = (
    permission: PermissionActions,
    actions: CommunityMemberPermissions['actions']
  ) => Boolean(actions?.some((action) => action === permission))

  return {
    hasAdminRole,
    hasCommunityManagementRole,
    hasPermission
  }
}

export default useUserPermissions
